/* Yotpo "Reviews with media" — 썸네일을 미리 받아 둔다 (2026-09-30)

   증상: 슬라이드를 넘기면 새 칸이 1~2초 비어 있다가 사진이 뜬다(파일마다 다르다).
   원인(라이브 EU vitano-matt-black 실측):
     · Yotpo 는 칸이 슬라이더 안에 들어온 **뒤에야** 썸네일 버튼에 background-image 를 넣는다.
       그래서 요청이 넘기는 순간 시작된다.
     · 썸네일은 4~9KB 로 작지만 **첫 요청**이 240~1670ms 걸린다 — Yotpo 이미지 CDN 이
       원본(40~105KB)을 그때 160×160 으로 만든다. 같은 주소 두 번째 요청은 ~40ms 다.
       "용량에 따라 다르다"는 체감이 이것이다(원본이 클수록 늦다).
   해결: 갤러리가 뜨면 Yotpo 가 이미 받아 둔 목록(`reviewsMedia` API)에서 모든 사진의
         썸네일 주소를 만들어 `new Image()` 로 미리 요청한다. 넘길 때 Yotpo 가 같은 주소를
         쓰면 브라우저 캐시에서 바로 나온다.

   ⚠️⚠️ **주소가 한 글자라도 다르면 캐시가 안 맞는다.** 썸네일 주소는
      `originalUrl` + Yotpo 가 붙이는 꼬리(`&format=webp&height=160&width=160` 등)다.
      꼬리를 여기 적어 두지 않고 **이미 뜬 첫 칸의 background-image 에서 떼어 낸다** —
      Yotpo 가 크기·형식을 바꾸거나 브라우저마다 다르게 붙여도 따라간다.
   ⚠️ 목록은 Yotpo 가 이미 부른 `reviewsMedia` 주소를 performance 기록에서 찾아 **같은 주소로**
      다시 읽는다(보통 캐시). 다음 페이지(page=2…)도 Yotpo 가 부르는 순간 따라 읽는다.
   ⚠️ 사진(`mediaType: image`)만 받는다. 영상 썸네일 주소 규칙은 확인하지 못했다.
   ⚠️ 한 장에 수 KB · 페이지당 20장이라 전부 받아도 100~200KB 수준이다. */
(() => {
  var GALLERY = '.yotpo-media-gallery-container';
  var API = /\/reviewsMedia\?/;
  var done = new Set();     /* 이미 요청한 썸네일 주소 */
  var read = new Set();     /* 이미 읽은 reviewsMedia 주소 */
  var media = [];           /* { originalUrl, mediaType } */
  var suffix = null;
  var keep = [];            /* 요청 중인 Image 가 수거되지 않게 잡아 둔다 */

  function bgUrl(el) {
    var m = /url\(["']?([^"')]+)["']?\)/.exec(getComputedStyle(el).backgroundImage || '');
    return m ? m[1] : null;
  }

  /* 뜬 칸 하나의 주소와 목록의 originalUrl 을 맞대어 Yotpo 가 붙인 꼬리를 얻는다. */
  function findSuffix() {
    if (suffix !== null) return suffix;
    var btns = document.querySelectorAll(GALLERY + ' .yotpo-single-thumbnail');
    for (var i = 0; i < btns.length; i++) {
      var u = bgUrl(btns[i]);
      if (!u) continue;
      for (var j = 0; j < media.length; j++) {
        var o = media[j].originalUrl;
        if (o && u.indexOf(o) === 0 && u.length > o.length) {
          suffix = u.slice(o.length);
          return suffix;
        }
      }
    }
    return null;
  }

  function preload() {
    if (findSuffix() === null) return;
    media.forEach(function (m) {
      if (m.mediaType !== 'image' || !m.originalUrl) return;
      var url = m.originalUrl + suffix;
      if (done.has(url)) return;
      done.add(url);
      var img = new Image();
      img.decoding = 'async';
      img.onload = img.onerror = function () {
        var k = keep.indexOf(img);
        if (k >= 0) keep.splice(k, 1);
      };
      keep.push(img);
      img.src = url;
    });
  }

  function readList(url) {
    if (read.has(url)) return;
    read.add(url);
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = j && j.response && j.response.reviewsMedia;
        if (!Array.isArray(list)) return;
        media = media.concat(list);
        preload();
      })
      .catch(function () {});
  }

  function scanEntries(entries) {
    entries.forEach(function (e) {
      if (API.test(e.name)) readList(e.name);
    });
  }

  function start() {
    scanEntries(performance.getEntriesByType('resource'));
    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (l) { scanEntries(l.getEntries()); })
          .observe({ type: 'resource', buffered: true });
      } catch (e) {}
    }
    /* 꼬리는 첫 칸이 그려진 뒤에야 알 수 있다 — 목록이 먼저 와도 여기서 다시 시도한다. */
    var tries = 0;
    var t = setInterval(function () {
      preload();
      if (suffix !== null || ++tries > 40) clearInterval(t);
    }, 250);
  }

  /* Yotpo 위젯은 스크롤해서 가까워져야 그려진다 — 갤러리가 생길 때까지 기다린다. */
  if (document.querySelector(GALLERY)) {
    start();
  } else {
    var mo = new MutationObserver(function () {
      if (!document.querySelector(GALLERY)) return;
      mo.disconnect();
      start();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
